export const myTeamcolourStyles = {
    option: (styles, { isFocused, isHovered }) => {
        return {
            ...styles,
            backgroundColor: isFocused || isHovered ? "#F6F5FF !important" : null,
            color: isFocused ? "#2c2c2c !important" : "#272727 !important" // Change text color when focused/unfocused
        };
    },
};
